const normalizeName = (value) => (
  typeof value === 'string' ? value.trim() : ''
);

export const getJiraFieldDisplayName = (field = {}) => {
  const translatedName = normalizeName(field.translated_name);
  const canonicalName = normalizeName(field.name);
  const fieldId = normalizeName(field.id || field.field_id);

  if (
    translatedName
    && canonicalName
    && translatedName.toLocaleLowerCase() !== canonicalName.toLocaleLowerCase()
  ) {
    return `${translatedName}（${canonicalName}）`;
  }

  return translatedName || canonicalName || fieldId;
};

export const matchesJiraFieldSearch = (field = {}, keyword = '') => {
  const normalizedKeyword = normalizeName(keyword).toLocaleLowerCase();
  if (!normalizedKeyword) {
    return true;
  }

  return [
    field.id,
    field.field_id,
    field.name,
    field.translated_name
  ].some(value => (
    normalizeName(value).toLocaleLowerCase().includes(normalizedKeyword)
  ));
};
